// 使用佳安方式的租户，目前国科大和佳安的区别仅限于样本接收的操作有不同
export default {
  permissions () {
    return this.$auth.user()
  },
  showStockQuantity () {
    return false
  },
  cookie () {
    return '4IWVrqSYW56WmG1pYmdsnG2dXFidntxTaoTQoZvLmZrTzpOalJ2i0oePWqWTpJmGcpdosw=='
  },
  getChipType (state) {
    return state.chipType
  }
}
